/* Shop by Brand — two-row rail with a true continuous loop.
   Ported from the approved Cloudflare preview (brands-c.html, option 2).

   The set MUST be an even number of tiles. With two rows and column flow, an
   odd count leaves a half-empty last column: the tiling breaks, and cloning
   drops clone #1 into that empty slot instead of starting a fresh column. The
   Liquid appends a "View all" tile, which makes 19 brands into 20 and fills the
   column with the one link the section was missing. If someone edits the block
   count to an odd number, the script pads with an inert spacer rather than
   letting the grid fall apart.

   Looping: wrapping by scrolling back to 0 reads as a rewind — the whole rail
   runs backwards past every tile. Instead the set is cloned once; Next always
   travels FORWARD and the rail is silently rebased by exactly one set width
   when it reaches the clones, which sit pixel-identical at that point.
*/
(function () {
  'use strict';

  var GAP = 8;

  function init(root) {
    if (!root || root.dataset.brReady === '1') return;

    var rail  = root.querySelector('[data-br-rail]');
    var pages = root.querySelector('[data-br-pages]');
    var prevB = root.querySelector('[data-br-prev]');
    var nextB = root.querySelector('[data-br-next]');
    if (!rail || !pages) return;
    root.dataset.brReady = '1';

    var items = [].slice.call(rail.children);
    if (items.length === 0) return;

    // Two rows need an even count or the last column is half empty.
    if (items.length % 2 === 1) {
      var pad = document.createElement('span');
      pad.className = 'br__pad';
      pad.setAttribute('aria-hidden', 'true');
      rail.appendChild(pad);
      items = [].slice.call(rail.children);
    }

    var N = items.length;
    var COLS = N / 2;

    function perView() { return window.matchMedia('(max-width: 749px)').matches ? 2 : 5; }
    var PER = perView();
    var nPages = Math.ceil(COLS / PER);

    if (COLS <= PER) {
      if (pages) pages.remove();
      if (prevB) prevB.remove();
      if (nextB) nextB.remove();
      return;
    }

    items.forEach(function (el) {
      var c = el.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.tabIndex = -1;
      rail.appendChild(c);
    });

    function colW()     { return items[0].getBoundingClientRect().width + GAP; }
    function pageStep() { return colW() * PER; }
    function setWidth() { return colW() * COLS; }

    var cur = 0, settle = null;

    function buildDots() {
      pages.innerHTML = '';
      for (var i = 0; i < nPages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Page ' + (i + 1));
        (function (n) { b.addEventListener('click', function () { go(n); }); })(i);
        pages.appendChild(b);
      }
    }
    function mark(n) {
      [].forEach.call(pages.children, function (d, k) {
        d.setAttribute('aria-current', k === n ? 'true' : 'false');
      });
    }
    function jump(px)  { rail.scrollTo({ left: px, behavior: 'instant' }); }
    function glide(px) { rail.scrollTo({ left: px, behavior: 'smooth' }); }
    function after(fn) { clearTimeout(settle); settle = setTimeout(fn, 760); }

    function go(n) {
      if (cur >= nPages) { jump(0); cur = 0; }
      glide(n * pageStep()); cur = n; mark(n);
    }
    if (nextB) nextB.addEventListener('click', function () {
      glide((cur + 1) * pageStep());
      cur = cur + 1;
      mark(cur % nPages);
      if (cur >= nPages) after(function () { jump(0); cur = 0; });
    });
    if (prevB) prevB.addEventListener('click', function () {
      if (cur === 0) { jump(setWidth()); cur = nPages; }
      glide((cur - 1) * pageStep());
      cur = cur - 1;
      mark(cur % nPages);
    });

    var t;
    rail.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var x = rail.scrollLeft;
        if (x >= setWidth() - 1) { jump(x - setWidth()); x = rail.scrollLeft; }
        cur = Math.round(x / pageStep()) % nPages;
        mark(cur);
      }, 110);
    }, { passive: true });

    window.addEventListener('resize', function () {
      var p = perView();
      if (p !== PER) { PER = p; nPages = Math.ceil(COLS / PER); cur = 0; buildDots(); }
      jump(cur * pageStep());
      mark(cur % nPages);
    }, { passive: true });

    buildDots();
    mark(0);
  }

  function boot(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-br]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
